import {
  whiteColor,
  oceanBlueColor,
  DodgerBlueColor,
} from "../../cmsMainStyle";

const rfiStyle = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  rfiInboxList: {
    height:
      window.outerHeight - (window.outerHeight - window.innerHeight + 320),
    overflowY: "auto",
    overflowX: "hidden",
  },
});

export { rfiStyle };
